import HeroSection   from "@/components/home/HeroSection";
import LeMouvement   from "@/components/home/LeMouvement";
import SystemExamplesSection from "@/components/home/SystemExamplesSection";
import SystemEcosystemSection from "@/components/home/SystemEcosystemSection";
import AssetSection  from "@/components/home/AssetSection";
import StandardSection from "@/components/home/StandardSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import AudienceSplitSection from "@/components/home/AudienceSplitSection";
import SellersSection from "@/components/home/SellersSection";
import PromoSection  from "@/components/home/PromoSection";
import PageValues from "@/components/PageValues";
import usePageMeta from "@/hooks/usePageMeta";

/*
  Structure optimisée pour le pré-lancement Premium
*/

export default function Home() {
  usePageMeta({
    title: "TANGIG — Des systèmes. Pas des heures.",
    description:
      "TANGIG distribue des systèmes opérationnels : des ensembles cohérents de méthodes, documentations, automatisations et IA qui produisent un résultat reproductible.",
    canonical: "https://tangig.com/",
    ogImage: "https://tangig.com/og-image.jpg",
  });
  return (
    <div style={{
      display: "flex",
      flexDirection: "column"
    }}>

      {/* Hero + "Le Mouvement" partagent un conteneur : le hero y est épinglé
          (sticky) et la section "Le Mouvement" grimpe par-dessus lui. isolation
          borne l'empilement pour que le hero épinglé ne recouvre pas la suite. */}
      <div style={{ position: "relative", isolation: "isolate" }}>
        <HeroSection />
        <LeMouvement />
      </div>

      {/* Separation band */}
      <div style={{ height: '15px', background: '#FFFFFF', width: '100%' }} />

      {/* On MONTRE avant d'expliquer : trois exemples de systemes arrivent
          juste apres le hero, pour que le visiteur voie l'objet avant qu'on
          lui definisse la categorie. */}
      <SystemExamplesSection />

      {/* Separation band */}
      <div style={{ height: '15px', background: '#FFFFFF', width: '100%' }} />

      {/* Les exemples montrent l'objet ; l'ecosysteme repond juste apres a la
          question que l'objet fait naitre : "ca marche avec ce que j'ai deja ?" */}
      <SystemEcosystemSection />

      {/* Separation band */}
      <div style={{ height: '15px', background: '#FFFFFF', width: '100%' }} />

      {/* La fenetre d'exemple vivait ici, dans sa propre section de
          definition : troisieme definition d'affilee avant qu'on explique
          enfin ce qui se passe a l'achat. Elle est passee DANS "Comment ca
          marche", qui montre desormais l'objet puis le parcours. */}
      {/* Les exemples montrent ce qu'un systeme fait ; il manquait ce qui se
          passe quand on en prend un. Les trois blocs ferment la partie
          acheteur, juste avant que la page change d'interlocuteur. */}
      <HowItWorksSection />

      {/* Coupure large, pas un simple filet : la page change d'interlocuteur
          juste apres, et le vide fait ce travail mieux qu'un titre. */}
      <div style={{ height: '120px', background: '#FFFFFF', width: '100%' }} />

      {/* Tout ce qui suit parle aux CREATEURS, pas aux entreprises qui
          achetent. L'aiguillage nomme les deux publics et donne a chacun sa
          porte : sans lui, le visiteur venu pour acheter tombait sans
          prevenir sur "vendez en continu" et ne savait plus ou il etait. */}
      <AudienceSplitSection />

      {/* Separation band */}
      <div style={{ height: '15px', background: '#FFFFFF', width: '100%' }} />

      {/* Grouped sections for immersive flow */}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <SellersSection />

        {/* Separation band */}
        <div style={{ height: '15px', background: '#FFFFFF', width: '100%' }} />

        <AssetSection />
      </div>

      {/* Separation band */}
      <div style={{ height: '15px', background: '#FFFFFF', width: '100%' }} />

      <StandardSection />
      <PromoSection />

      {/* Separation band */}
      <div style={{ height: '15px', background: '#FFFFFF', width: '100%' }} />

      {/* Pre-footer commun a toutes les pages publiques : meme bloc, meme
          design, quelle que soit la porte d'entree du visiteur. */}
      <PageValues />
    </div>
  );
}
